import { useEffect, useState } from "react";
import { API_GET2 } from "../API/config";
import { API_endspoints } from "../API/API_endspoints";

const useStateList = () => {
    const [stateList, setStateList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchList = async () => {
        try
        {
            let res = await API_GET2(API_endspoints.getStates);
            if (res?.s)
            {
                setStateList(res?.r);
            } else
            {
                console.log(error)
            }
        } catch (error)
        {
            setError(error.message);
        } finally
        {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    return { stateList, loading, error };
};

export default useStateList;
